export const SentryTransactionNames = {
  PART_SPLIT_EVENT_RECEIVED: 'Part Split Event - Received',
  PART_HIDDEN_FLAG_UPDATED_EVENT_RECEIVED: 'Part Hidden Flag Updated Event - Received',
  ASSEMBLY_PARTS_UPDATED_EVENT: 'Assembly Part Updated - Received',
  PART_ADDED_TO_ASSEMBLY_EVENT: 'Part Added to Assembly - Received',
  BUILDING_STRUCTURE_RELATIONSHIP: 'Building Structure Relationships',
};
